import { createApp } from 'vue'
import  PagePopup from './PagePopup.vue'

function CustomPagePopup(data) {
  return new Promise((resolve, reject) => {
    // 实例化组件，createApp第二个参数是props
    const myPopup = createApp(PagePopup, {
      data,
      doComfirm: () => {
        unmount()
        resolve()
      },
      doCancel: (status=false) => {
        unmount()
        reject(new Error())
      }
    })
    const unmount = () => {
      myPopup.unmount()
      document.body.removeChild(parentNode)
    }
    // 创建一个挂载容器
    const parentNode = document.createElement('div')
    document.body.appendChild(parentNode)
    // 挂载组件
    myPopup.mount(parentNode)
  })
}

export default CustomPagePopup